import { CopyAmountToAllBookingItem } from "@/models/api/commands/booking/CopyAmountToAllBookingItem";

export class CopyFareBaseToAllBookingItem extends CopyAmountToAllBookingItem {
  CommandName = "CopyFareBaseToAllBookingItem";

  constructor(sessionId: string, operationId: string, fareBaseInCurrency: number) {
    super(sessionId, operationId, fareBaseInCurrency, "", 0, null, null);
  }
}
